import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { preferencesV2Selectors } from 'app-components/flux/preferences-v2';
import { transactionsActions, transactionsSelectors } from 'app-components/flux/transactions';

import { resetTTI } from 'utils/tti';

const TransactionsGarbageCollect = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const pathnameL1 = pathname.split('/')[1];
  const isLoading = useSelector(transactionsSelectors.getIsLoading);
  const dateOnAfterDB = useSelector(transactionsSelectors.getDateOnAfter);
  const dateOnAfterPref = useSelector((state) => preferencesV2Selectors.getPreferenceValue(state, 'dateOnAfter'));
  useEffect(
    () => {
      // reset transaction only on feature changes
      if (dateOnAfterDB !== dateOnAfterPref && !isLoading) {
        resetTTI();
        dispatch(
          transactionsActions.getTransactions(undefined, {
            context: 'transactions reset',
            props: { dateOnAfter: null },
          }),
        );
      }
    },
    [pathnameL1], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return null;
};
export default TransactionsGarbageCollect;
